import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=7a479f6f&scoped=true"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"
import style0 from "./RolesList.vue?vue&type=style&index=0&id=7a479f6f&prod&lang=scss&scoped=true"
import style1 from "./RolesList.vue?vue&type=style&index=1&id=7a479f6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a479f6f",
  null
  
)

export default component.exports